export const LADE_KATEGORIEN = "ladeKategorien"
export const LADE_BERECHTIGUNGEN = "ladeBerechtigungen"
export const LADE_USER = "ladeUser"
export const LOGOUT = "logout"
